import { ReactElement, MouseEventHandler } from "react";
import { SvgWrapper } from "./SvgWrapper";
import { IconButton, Tooltip } from "@mui/material";
import { Stack, fontSize } from "@mui/system";

/**
 * @param {object} props
 * @param {MouseEventHandler} props.onClick
 * @param {Number} props.toolbarIconOrder
 * @returns {ReactElement}
 */
export const ShareUrlButton = ({ onClick, toolbarIconOrder = -1 }) => {
  const iconJSX = (
    <SvgWrapper
      filename="ShareIcon"
      sx={{ "&:hover": { color: "#0c3153" }, fontSize: "1.3rem", mt: "2px" }}
    />
  );

  const buttonJSX = (
    <Stack style={{ order: toolbarIconOrder }}>
      <Tooltip title="Share">
        <IconButton onClick={onClick}>{iconJSX}</IconButton>
      </Tooltip>
    </Stack>
  );
  return buttonJSX;
};
